import { render, staticRenderFns } from "./PatientHistoryItem.vue?vue&type=template&id=052ccf6f&scoped=true&lang=pug&"
import script from "./PatientHistoryItem.vue?vue&type=script&lang=js&"
export * from "./PatientHistoryItem.vue?vue&type=script&lang=js&"
import style0 from "./PatientHistoryItem.vue?vue&type=style&index=0&id=052ccf6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052ccf6f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
